module.exports = __webpack_public_path__ + "img/cc_complete_midtrans.b5c51979.svg";